import card from '../payment-methods/card.json';

export const DEFAULT_PAYMENT_METHOD = {
  id: 'card',
  name: 'Card',
  metadata: card,
};
